'use client';
import React from 'react';

export default function TopBar() {
  return (
    <div className="relative z-50 flex flex-wrap items-center justify-between gap-2 border-b border-white/5 bg-forest-dark px-4 py-2 font-sans text-xs text-cream md:text-sm">
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        <a
          href="https://wa.me/9779700193326"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1.5 hover:text-saffron-light transition-colors"
        >
          <span className="inline-block h-2 w-2 rounded-full bg-emerald-500 animate-ping"></span>
          WhatsApp Chat:{' '}
          <span className="font-semibold text-emerald-400">+9779700193326</span>
        </a>
        <a
          href="tel:+9779700193326"
          className="hidden sm:flex items-center gap-1.5 hover:text-saffron-light transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-saffron-light" aria-hidden="true">
            <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" />
          </svg>
          <span>+977 9700193326</span>
        </a>
        <a
          href="mailto:YogaBowls.us@gmail.com"
          className="flex items-center gap-1.5 hover:text-saffron-light transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-saffron-light" aria-hidden="true">
            <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" />
            <rect x="2" y="4" width="20" height="16" rx="2" />
          </svg>
          <span>YogaBowls.us@gmail.com</span>
        </a>
      </div>
      <div aria-label="Social media" className="flex flex-wrap items-center gap-1.5">
        <a
          href="https://www.facebook.com/yogabowls"
          target="_blank"
          rel="noopener noreferrer"
          className="rounded-full border border-white/20 bg-white/5 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-cream transition-all hover:border-saffron-light/60 hover:bg-saffron-light hover:text-forest-dark md:text-xs"
        >
          Facebook
        </a>
        <a
          href="https://www.instagram.com/yogabowls.us"
          target="_blank"
          rel="noopener noreferrer"
          className="rounded-full border border-white/20 bg-white/5 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-cream transition-all hover:border-saffron-light/60 hover:bg-saffron-light hover:text-forest-dark md:text-xs"
        >
          Instagram
        </a>
        <a
          href="https://www.youtube.com/@yogabowls"
          target="_blank"
          rel="noopener noreferrer"
          className="rounded-full border border-white/20 bg-white/5 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-cream transition-all hover:border-saffron-light/60 hover:bg-saffron-light hover:text-forest-dark md:text-xs"
        >
          YouTube
        </a>
        <span className="cursor-not-allowed rounded-full border border-white/10 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-cream/45 md:text-xs">
          LinkedIn
        </span>
      </div>
    </div>
  );
}
